export default __webpack_public_path__ + "static/productconfigold-8c470cc41ef401f8e75b0542256bf0a7.jpg";